var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobStarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58337 7.58333C1.58337 7.58333 1.64909 8.04334 3.5529 9.94715C5.4567 11.851 8.54338 11.851 10.4472 9.94715C11.1217 9.27262 11.5572 8.44961 11.7538 7.58333M1.58337 7.58333V10.8333M1.58337 7.58333H4.83337M12.4167 5.41667C12.4167 5.41667 12.351 4.95666 10.4472 3.05285C8.54338 1.14905 5.4567 1.14905 3.5529 3.05285C2.87837 3.72738 2.44283 4.55039 2.24628 5.41667M12.4167 5.41667V2.16667M12.4167 5.41667H9.16671",
    stroke: "#6AAFDC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobStarted);
export default __webpack_public_path__ + "static/media/JobStarted.be384ccda2b98e5149b2435e0f791fd9.svg";
export { ForwardRef as ReactComponent };